// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2mfu_","question":"Question_question__1qih9","description":"Question_description__2CLPS"};